// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

import LocatorPageContainer from '@/components/containers/store/LocatorPageContainer.vue';
import storeSearch from '@/modules/store-search';
import storeResults from '@/modules/storeresults';
import Handlebars from 'handlebars';
import '@/vendor/acc.storefinder';
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';
import slider from '@/modules/slider';

// Vue Components
import '@sassRoot/entryPoints/b2c/store-finder-v1.scss';

class StoreFinderV1 extends Shell {
  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();

    window.Handlebars = Handlebars;
  }
}

const storeFinder = new StoreFinderV1({LocatorPageContainer});
storeFinder.initializeVue();

$(document).ready(() => {
  const element = $(document);
  storeFinder.globalDocumentReadyInits();

  if ($('#storesearch_js_id').length) {
    storeSearch(element);
  }

  if ($('#storeresults_js_id').length) {
    storeResults(element);
  }

  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });
});

$(window).on('load', () => {
  storeFinder.globalOnLoadInits();
});
